export const bounceOutRight = [{
  offset: 0.2,
  opacity: '1',
  transform: 'translate3d(-20px, 0, 0) scaleX(0.9)'
}, {
  offset: 1,
  opacity: '0',
  transform: 'translate3d(2000px, 0, 0) scaleX(2)'
}];